import React, { Component } from "react";

export default class BetterBox extends Component {
    constructor() {
        super();

        this.state = {
            isOpen: true,
        };
    }

    componentDidMount = () => {
        this.setState({ isOpen: !Boolean(this.props?.filtro) });
    };

    open = () => {
        this.setState({ isOpen: !this.state.isOpen });
    };

    render() {
        const { title, subtitle, conferencia, conferencia_ativo, accordion, actions, children, mostrar_tabela, setMostrarTabela, refresh_kanban } = this.props;

        return (
            <div className="kt-portlet">
                {(title || subtitle) && (
                    <div className="kt-portlet__head">
                        <div className="kt-portlet__head-label" style={setMostrarTabela ? { display: "flex !important", flex: "1", justifyContent: "space-between" } : null}>
                            {conferencia && (
                                <div className={conferencia_ativo ? "check-informacao" : "minus-informacao"}>
                                    <i className={conferencia_ativo ? "fas fa-check" : "fas fa-minus"} style={{ fontSize: "17px" }}></i>
                                </div>
                            )}

                            <h3 className="kt-portlet__head-title">
                                {title}
                                {subtitle ? <small>{subtitle}</small> : null}
                            </h3>

                            {setMostrarTabela && (
                                <div className="container-mostrar-tabela">
                                    <div className={mostrar_tabela ? "mostrar-tabela-select" : "mostrar-tabela"} onClick={() => setMostrarTabela(true)}>
                                        <i className={`fas fa-list`} />
                                    </div>

                                    <div
                                        className={!mostrar_tabela ? "mostrar-tabela-select" : "mostrar-tabela"}
                                        onClick={() => {
                                            if (refresh_kanban && mostrar_tabela) {
                                                refresh_kanban();
                                            }

                                            setMostrarTabela(false);
                                        }}
                                    >
                                        <i className={`fas fa-border-all`} />
                                    </div>
                                </div>
                            )}
                        </div>

                        {accordion && (
                            <div onClick={this.open} style={{ display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }}>
                                <i className={this.state.isOpen ? "fas fa-chevron-up" : "fas fa-plus"} style={{ fontSize: "23px" }}></i>
                            </div>
                        )}
                    </div>
                )}

                {this.state.isOpen && (
                    <div className="kt-portlet__body" style={this.props.style ?? {}}>
                        <div className="kt-portlet__preview">
                            <div>
                                {actions ? (
                                    <div>
                                        {actions}
                                        <div className="kt-separator kt-separator--dashed"></div>
                                    </div>
                                ) : null}

                                {children ? <div className="kt-section__content">{children}</div> : null}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
